var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "q-card",
        {
          staticClass: "md-card q-mt-lg q-pa-lg relative-position",
          attrs: { color: "white", "text-color": "black" }
        },
        [
          _c("q-card-title", [_c("h4", [_vm._v("AGC-MN Privacy Policy")])]),
          _c("q-card-separator"),
          _c("q-card-main", [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-12 l-lg-pad r-lg-pad" }, [
                _c("p", [
                  _vm._v(
                    "This Privacy Policy describes how and what personal information Associated General Contractors of\n            Minnesota (AGC-MN) collects, uses and shares when you visit\n            or make a purchase from https://agcmn.org (the “Site”)."
                  )
                ]),
                _c("h5", [_vm._v("Information Collection ")]),
                _c("p", [
                  _vm._v(
                    "When you visit the Site, we automatically collect certain information about your device, including\n            information about your web browser, IP address, time zone, and some of the cookies that are installed on\n            your device. Additionally, as you browse the Site, we collect information about the individual web pages\n            or products that you view, what websites or search terms referred you to the Site, and information about\n            how you interact with the Site. We refer to this automatically-collected information as “Device\n            Information.”"
                  )
                ]),
                _c("ul", [
                  _c("li", [
                    _vm._v("Your name, email address, and contact information")
                  ]),
                  _c("li", [
                    _vm._v(
                      "Your credit card details and applicable billing information"
                    )
                  ]),
                  _c("li", [
                    _vm._v(
                      "Credentials to services that you use (third-party services)"
                    )
                  ]),
                  _c("li", [
                    _vm._v(
                      "Any other information that you put into our support portal account."
                    )
                  ])
                ]),
                _c("h5", [_vm._v("Information Collection Methods")]),
                _c("p", [
                  _vm._v(
                    "“Cookies” are data files that are placed on your device or computer and often include an anonymous unique\n            identifier. For more information about cookies, and how to disable cookies, visit\n            http://www.allaboutcookies.org. For more information, please refer to our Cookie Policy"
                  )
                ]),
                _c("p", [
                  _vm._v(
                    "“Log files” track actions occurring on the Site, and collect data including your IP address, browser\n            type, Internet service provider, referring/exit pages, and date/time stamps. "
                  )
                ]),
                _c("p", [
                  _vm._v(
                    "“Web beacons,” “tags,” and “pixels” are electronic files used to record information about how you browse\n            the Site."
                  )
                ]),
                _c("p", [
                  _vm._v(
                    "Additionally, when you make a purchase or attempt to make a purchase through our online store, we collect\n            certain information from you, including your name, billing address, payment information (including credit\n            card numbers), email address, and phone number. We refer to this information as “Order Information.”"
                  )
                ]),
                _c("h5", [_vm._v("How Do We Use Your Information?")]),
                _c("p", [
                  _vm._v(
                    "We use the Order Information that we collect generally to activate paid subscriptions placed through the\n            Online Store (including processing your payment information, arranging for monthly or annual billing, and\n            providing you with invoices and/or order confirmations). Additionally, we use this Order Information\n            to:"
                  )
                ]),
                _c("ul", [
                  _c("li", [_vm._v("Communicate with you;")]),
                  _c("li", [
                    _vm._v("Schedule recurring monthly or annual billing;")
                  ]),
                  _c("li", [_vm._v("Collect payments from you;")]),
                  _c("li", [
                    _vm._v("Screen our orders for potential risk or fraud; and")
                  ]),
                  _c("li", [
                    _vm._v(
                      "When in line with the preferences you have shared with us, provide you with information or advertising\n              relating to our products or services.\n            "
                    )
                  ])
                ]),
                _c("p", [
                  _vm._v(
                    "We use the Device Information that we collect to help us screen for potential risk and fraud (for\n            example, your IP address), and more generally to improve and optimize our Site (for example, by generating\n            analytics about how our customers browse and interact with the Site, and to assess the success of our\n            marketing and advertising campaigns). "
                  )
                ]),
                _c("p", [
                  _vm._v(
                    "In addition, we may use your information to do the following:"
                  )
                ]),
                _c("ul", [
                  _c("li", [
                    _vm._v("Administer service of our product offerings;")
                  ]),
                  _c("li", [
                    _vm._v("Administer service to our support portal(s);")
                  ]),
                  _c("li", [
                    _vm._v(
                      "Enable your access to and use of the third-party web services;"
                    )
                  ]),
                  _c("li", [_vm._v("Send you service updates.")])
                ]),
                _c("h5", [_vm._v("Sharing Your Personal Information")]),
                _c("p", [
                  _vm._v(
                    "We share your Personal Information with third parties to help us use your Personal Information, as\n            described above. For example, we use a third-party serviced called Google Analytics to help us understand\n            how our customers use the Site--you can\n            read more about how Google uses your Personal Information here:\n            https://www.google.com/intl/en/policies/privacy/. You can also opt-out of Google Analytics here:\n            https://tools.google.com/dlpage/gaoptout."
                  )
                ]),
                _c("p", [
                  _vm._v(
                    "Finally, we may also share your Personal Information to comply with applicable laws and regulations, to\n            respond to a subpoena, search warrant or other lawful request for information we receive, or to otherwise\n            protect our rights. "
                  )
                ]),
                _c("h5", [_vm._v("Securing Your Data")]),
                _c("p", [
                  _vm._v(
                    "AGC-MN will take reasonable technical and organizational precautions to prevent the loss or misuse of\n            your saved order and personal information."
                  )
                ]),
                _c("p", [
                  _vm._v(
                    "AGC-MN will store all the personal information you provide on its secure servers apart from your credit\n            card details. We use our secure payment partner (Quickbooks Payments:\n            https://quickbooks.intuit.com/payments/) to process these payments and we do not have\n            access to your card."
                  )
                ]),
                _c("h5", [_vm._v("Do Not Track")]),
                _c("p", [
                  _vm._v(
                    "Please note that we do not alter our Site’s data collection and use practices when we see a Do Not Track\n            signal from your browser."
                  )
                ]),
                _c("h5", [_vm._v("Minors")]),
                _c("p", [
                  _vm._v(
                    "The Site is not intended for individuals under the age of 18."
                  )
                ]),
                _c("h5", [_vm._v("Changes to This Document")]),
                _c("p", [
                  _vm._v(
                    "AGC-MN may at any time, without notice to you, and in its sole discretion, update this\n            privacy policy from time to time in order to reflect, for example, changes to our practices or for other\n            operational, legal or regulatory reasons. Please review this policy periodically. "
                  )
                ]),
                _c("p", [
                  _vm._v(
                    "AGC-MN is not responsible for the privacy policies or practices of any third party. "
                  )
                ]),
                _c("h5", [_vm._v("Contact AGC-MN")]),
                _c("p", [
                  _vm._v(
                    "If you have any questions about this privacy policy, AGC-MN’ treatment of your information,\n            or wish to submit a request to delete your information, please send e-mail to: info@agcmn.org. "
                  )
                ])
              ])
            ])
          ])
        ],
        1
      ),
      _c("router-view")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }